import React, { useState, useEffect } from "react";
import "./styles.css";
import { useLocation } from "react-router-dom";
const ReallyMovingLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 844);
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  const updateIsMobile = () => {
    setIsMobile(window.innerWidth <= 844);
  };

  useEffect(() => {
    window.addEventListener("resize", updateIsMobile);
    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  if (
    process.env.REACT_APP_MODE !== "prod-reallymoving" &&
    process.env.REACT_APP_MODE !== "prod-justmovein" &&
    process.env.REACT_APP_MODE !== "prod-homebox" &&
    process.env.REACT_APP_MODE !== "prod-housr"
  )
    return <div className="container-styles">{children}</div>;

  return (
    <div className="container-styles">
      {!isLoginPage && (
        <header className="menu-header">
          <div className="menu-inner">
            <div className="left">
              {process.env.REACT_APP_MODE === "prod-reallymoving" && (
                <a
                  href="https://www.reallymoving.com/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    className={
                      isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                    }
                    src="https://media.umbraco.io/reallymoving2/mwpcygsj/rm-logo-25yrs-uncropped.svg"
                    alt="ReallyMoving"
                  />
                </a>
              )}
              {process.env.REACT_APP_MODE === "prod-justmovein" && (
                <img
                  className={
                    isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                  }
                  src={require("../../Assets/icons/justmovein.svg")}
                  alt="JustMoveIn"
                />
              )}

              {process.env.REACT_APP_MODE === "prod-homebox" && (
                <a
                  href="https://www.homebox.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    className={
                      isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                    }
                    src={require("../../Assets/images/homeboxlogo.png")}
                    alt="Homebox"
                  />
                </a>
              )}
              {process.env.REACT_APP_MODE === "prod-housr" && (
                <a
                  href="https://www.housr.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    className={
                      isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                    }
                    src={require("../../Assets/icons/housr-logo.png")}
                    alt="Housr"
                  />
                </a>
              )}

              {isMobile && (
                <a
                  href="https://app.moveinout.co.uk/getStarted"
                  className="chapperone-logo-wrapper"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    className="st-navbar-icon chapperone-logo-mobile"
                    src={require("../../Assets/images/Moveinout-logo.png")}
                    alt="MoveInOut"
                  />
                </a>
              )}
            </div>
          </div>
        </header>
      )}

      {children}
    </div>
  );
};

export default ReallyMovingLayout;
